import React from 'react';
import store from 'store';
import { Collapse } from 'antd';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { config } from '../../../../utils/config';
import styles from './FooterMobileMenu.module.scss';

// Components
import Button from '../../Button';

const { Panel } = Collapse;

interface IFooterMobileMenu {
    handleClose?: () => void;
}

const FooterMobileMenu: React.FC<IFooterMobileMenu> = ({ handleClose }) => {
    const isPWA = store.get(config.user.isPWA);
    const isLoggedIn = store.get(config.user.authToken);

    return (
        <Collapse
            accordion
            bordered={false}
            expandIconPosition={'end'}
            className={classNames(styles.antCollapse, { [styles.blackColor]: isPWA })}
        >
            <Panel key="1" header="Linkuri utile" className={styles.antPanel}>
                <ul>
                    <li>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={config.path.iqos.iqosContacteaza}
                            className={isPWA ? styles.colorBlack : styles.colorWhite}
                        >
                            Contact
                        </a>
                    </li>
                    <li>
                        <a
                            href={'/scan/lista-castigatori'}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={isPWA ? styles.colorBlack : styles.colorWhite}
                        >
                            Listă câștigători
                        </a>
                    </li>
                </ul>
            </Panel>

            <Panel key="3" header="Legal">
                <ul>
                    <li>
                        <Button
                            href="http://www.anpc.gov.ro"
                            target="_blank"
                            type="text"
                            className={isPWA ? styles.colorBlack : styles.colorWhite}
                        >
                            ANPC
                        </Button>
                    </li>
                    <li>
                        {isLoggedIn ? (
                            <div />
                        ) : (
                            <a
                                href={config.path.iqos.termsConditions}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={isPWA ? styles.colorBlack : styles.colorWhite}
                            >
                                Termeni și condiții
                            </a>
                        )}
                    </li>

                    <li>
                        <a
                            href={config.path.iqos.privacy}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={isPWA ? styles.colorBlack : styles.colorWhite}
                        >
                            Protectia datelor personale
                        </a>
                    </li>
                    <li>
                        <a
                            href={config.path.iqos.cookiesPolicy}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={isPWA ? styles.colorBlack : styles.colorWhite}
                        >
                            Politică de cookies
                        </a>
                    </li>
                    <li>
                        <button
                            id="ot-sdk-btn"
                            className={classNames('ot-sdk-show-settings', {
                                [styles.colorBlack]: isPWA,
                                [styles.colorWhite]: !isPWA
                            })}
                        >
                            Gestionează cookies
                        </button>
                    </li>
                    <li>
                        <a
                            href={config.path.regulament}
                            target="_blank"
                            download
                            rel="noopener noreferrer"
                            className={isPWA ? styles.colorBlack : styles.colorWhite}
                        >
                            Regulamentul campaniei
                        </a>
                    </li>
                </ul>
            </Panel>
        </Collapse>
    );
};

export default FooterMobileMenu;
